import { Icon, type Icons } from '../icon';
import { cn } from '../lib/utils';

import { useChipSize } from '../chip/chip-context';
import { iconGlyphSize } from '../chip/tokens';

type Props = {
  /** Glyph name from the `Icons` enum. */
  name: Icons;
  className?: string;
};

/** System glyph sized to fit inside a `<Chip>`. Use when an entity is
 *  represented by an icon (workspace, external share, system action) —
 *  sibling to `<Avatar>` and `<Flag>`. The component reads its size from
 *  the parent chip via context. */
export const Glyph = ({ name, className }: Props) => {
  const size = useChipSize();
  return <Icon name={name} className={cn(iconGlyphSize[size], className)} />;
};

export type { Props as GlyphProps };
